import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import dataProvider from "server/dataProvider";
import { scholarshipRequests } from "api/scholarshipApi";

const ApproveDialog = ({ id }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(scholarshipRequests.approveScholarshipApplication(id), null, "PUT");
    refresh();
    notify("Успешно одобрихте кандидатурата!", { type: "success" });
  };
  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={"Одобряване на кандидатура за стипендия"}
      message="Сигурни ли сте, че искате да одобрите кандидатурата за стипендия?"
      triggerButton={
        <Button
          label="Одобри"
          variant="contained"
          startIcon={<CheckCircleOutlineIcon />}
          color="success"
        />
      }
    />
  );
};

export default ApproveDialog;
